import { Directive, ElementRef, Input, Renderer2, OnChanges } from '@angular/core';

@Directive({
    selector: '[appScale]',
    standalone: false
})
export class ScaleDirective implements OnChanges {
  @Input() scale: any = 1;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges() {
    this.renderer.setStyle(this.el.nativeElement, 'transform', `scale(${this.scale})`);
  }
}
